import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/Customer.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";

export default function Customer() {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [CustomerList, SetCustomerList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

  const filteredCustomerList = searchQuery
    ? CustomerList.filter((item) =>
        item.Customer_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : CustomerList;

  const InitState = {
    customerName: null,
    aadharNumber: null,
    gender: "Male",
    contactNumber1: null,
    contactNumber2: null,
    address: null,
    reference: null,
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const fetchCustomerList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/customer/FetchCustomerList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
      // console.log(response.data)
      SetCustomerList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchCustomerList();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (customer) => {
    const InitStateEdit = {
      customerId: customer.Customer_Id,
      customerName: customer.Customer_Name,
      aadharNumber: customer.Aadhar_Number,
      gender: customer.Gender,
      contactNumber1: customer.Contact1,
      contactNumber2: customer.Contact2,
      address: customer.Address,
      reference: customer.Reference,
      user: passedState.username,
    };
    setSelectedCustomer(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if(confirmClose){
      setModalIsOpen(false);
      setFormData(InitState);
      setSelectedCustomer(null);
    }
    
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value);
    const pattern = /[^a-zA-Z\s ]/g;
    if (name === "customerName") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "reference") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "contactNumber1" || name === "contactNumber2") {
      if (value > 9999999999) {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else if (name === "aadharNumber") {
      if (value > 999999999999) {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 12),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (name === "customerName") {
      let result = pattern.test(value);
      if (result) {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(/[^a-zA-Z\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "reference") {
      let result = pattern.test(value);
      if (result) {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value,
        });
      }
    } else if (name === "contactNumber1" || name === "contactNumber2") {
      if (value > 9999999999) {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
        });
      } else {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else if (name === "aadharNumber") {
      if (value > 999999999999) {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 12),
        });
      } else {
        setSelectedCustomer({
          ...selectedCustomer,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else {
      setSelectedCustomer({
        ...selectedCustomer,
        [name]: value,
      });
    }
  };

  const UpdateForm = () => {
    //console.log(selectedCustomer)
    try {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/customer/UpdateCustomer/${selectedCustomer.customerId}`,
          selectedCustomer,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedCustomer([]);
          fetchCustomerList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    closeModal();
  };
  const handleDelete = (customer) => {
    try {
      const confirm= window.confirm("Are you sure you want to delete this?")
      if(!confirm) return
      axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/customer/DeleteCustomer/${customer.Customer_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            fetchCustomerList();
          } else if (res.status === 500) {
            FailedMSG(res.data.message);
            window.location.reload();
          }
          fetchCustomerList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      //console.log(formData);
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/customer/AddCustomer`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          fetchCustomerList();
          SuccessMSG(res.data.message);
          setFormData([]);
          fetchCustomerList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG(error.response.data.error);
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    setFormData(InitState);
    closeModal();
  };

  return (
    <>
      <ToastContainer />
      <Appbar
        username={passedState.username}
        rights={passedState.rights}
      ></Appbar>
      <div className="Customer">
        <Menu
          username={passedState.username}
          rights={passedState.rights}
          i={"MasterSetup"}
        ></Menu>
        <div className="CustomerPage">
          <p className="CustomerHeadLabel">Customer</p>
          <div className="CustomerHeaders">
            <div className="CustomerRegSearch">
              <input
                className="CustomerRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Customer Name"
              ></input>
              <button className="CustomerSearchBtn">
                <FontAwesomeIcon
                  className="CustomerRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewCustomerBtn"
              title="Add New"
              onClick={openModal}
            >
              Add New{" "}
              <FontAwesomeIcon
                className="CustomerAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            contentLabel="Customer Form"
            shouldCloseOnOverlayClick={false} // Prevents closing on outside click
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "auto",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="CustomerFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="CustomerFormHeadLabel">
              {selectedCustomer?.customerId ? "Edit Customer" : "Add Customer"}
            </p>
            <form
              className="CustomerForm"
              onSubmit={
                selectedCustomer?.customerId ? UpdateForm : handleSubmit
              }
            >
              <div className="CustomerFormFlex">
                <div className="Customerform1">
                  <div className="CustomerformFeilds">
                    <label className="CustomerFormLabels">
                      Customer Name <span>*</span>{" "}
                    </label>
                    <input
                      placeholder="Customer Name"
                      value={
                        selectedCustomer
                          ? selectedCustomer.customerName
                          : formData.customerName
                      }
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      className="CustomerFormInputs"
                      required
                      type="text"
                      name="customerName"
                    ></input>
                  </div>
                </div>
                <div className="Customerform1">
                  <div className="CustomerformFeilds">
                    <label className="CustomerFormLabels">Aadhar Number </label>
                    <input
                      placeholder="Aadhar Number"
                      minLength={12}
                      maxLength={12}
                      title="Please give 12 digit"
                      value={
                        selectedCustomer?.aadharNumber || formData.aadharNumber
                      }
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      className="CustomerFormInputs"
                      type="text"
                      name="aadharNumber"
                      
                    ></input>
                  </div>
                  <div className="CustomerformFeilds">
                    <label className="CustomerFormLabels">Gender</label>
                    <select
                      className="CustomerFormInputs2"
                      value={selectedCustomer?.gender || formData.gender}
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      name="gender"
                    >
                      <option>Male</option>
                      <option>Female</option>
                      <option>Transgender</option>
                    </select>
                  </div>
                </div>
                <div className="Customerform1">
                  <div className="CustomerformFeilds">
                    <label className="CustomerFormLabels">
                      Contact Number 1 <span>*</span>
                    </label>
                    <input
                      placeholder="Contact Number"
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      value={
                        selectedCustomer?.contactNumber1 ||
                        formData.contactNumber1
                      }
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      required
                      className="CustomerFormInputs"
                      type="text"
                      name="contactNumber1"
                    ></input>
                  </div>
                  <div className="CustomerformFeilds">
                    <label className="CustomerFormLabels">
                      Contact Number 2{selectedCustomer?<span>*</span>:''}
                    </label>
                    <input
                      placeholder="Contact Number"
                      className="CustomerFormInputs"
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      value={
                        selectedCustomer?.contactNumber2 ||
                        formData.contactNumber2
                      }
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      type="text"
                      name="contactNumber2"
                    ></input>
                  </div>
                </div>
                <div className="Customerform1">
                  <div className="CustomerformFeilds1">
                    <label className="CustomerFormLabels">Address </label>
                    <textarea
                      placeholder="Address"
                      value={selectedCustomer?.address || formData.address}
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      className="CustomerFormInputs1"
                      type="text"
                      name="address"
                    ></textarea>
                  </div>
                </div>
                <div className="Customerform1">
                  <div className="CustomerformFeilds1">
                    <label className="CustomerFormLabels">Reference</label>
                    <textarea
                      placeholder="Reference"
                      className="CustomerFormInputs1"
                      value={selectedCustomer?.reference || formData.reference}
                      onChange={selectedCustomer ? handleUpdate : handleChange}
                      type="text"
                      name="reference"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="CustomerFormFooter">
                <div className="CustomerFormFooterBtns">
                  <button
                    className="CustomerFormSubmitBtn"
                    title="Confirm"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <div className="CustomerLists">
            {filteredCustomerList.length < 1 ? (
              <p style={{textAlign:"center", width:"100%"}}>There are no customers</p>
            ) : (
              filteredCustomerList.map((items, index) => (
                <div key={index} className="CustomerIndex">
                  <div className="CustomerGrp0">
                    <div className="CustomerIconGrp">
                      {console.log(items)}
                     {items.customer_Photo ? (
                                               <img
                                                 src={`${process.env.REACT_APP_API_BASE_URL}${
                                                   items.customer_Photo
                                                     ? items.customer_Photo.replace(
                                                         /public\\/g,
                                                         "/"
                                                       )
                                                     : ""
                                                 }`}
                                                 className="CustomerImageCircle"
                                                 alt="Customer"
                                               ></img>
                                             ) : (
                                               <FontAwesomeIcon
                                                 className="DriverUsesCircle"
                                                 icon={faUserCircle}
                                               ></FontAwesomeIcon>
                                             )}
                    </div>
                    <div className="CustomerGrp" style={{ width: "40%" }}>
                      <p className="CustomerGrpLables">Id</p>
                      <p className="CustomerGrpValues">{items.Customer_Id}</p>
                    </div>
                    <div className="CustomerGrp" style={{ width: "80%" }}>
                      <p className="CustomerGrpLables">Customer Name</p>
                      <p className="CustomerGrpValues">{items.Customer_Name}</p>
                    </div>
                  </div>
                  <div className="CustomerGrp">
                    <p className="CustomerGrpLables">Customer Contact</p>
                    <p className="CustomerGrpValues">{items.Contact1}</p>
                  </div>
                  <div className="CustomerGrp">
                    <p className="CustomerGrpLables">Aadhar Number</p>
                    <p className="CustomerGrpValues">
                      {items.Aadhar_Number ? items.Aadhar_Number : "----"}
                    </p>
                  </div>
                  <div className="CustomerGrpBtn">
                    <FontAwesomeIcon
                      className="CustomerEditIcon"
                      title="Edit"
                      icon={faEdit}
                      onClick={() => handleEdit(items)}
                    />
                    <FontAwesomeIcon
                      className="CustomerDeleteIcon"
                      title="Delete"
                      onClick={() => handleDelete(items)}
                      icon={faTrash}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

/*

                {CustomerList.length <1 ? <p>There is No Customers</p>:
                CustomerList.map((items,index)=>{
                    return <><div className='CustomerIndex'>
                    <div className='CustomerGrp0'>
                      <div className='CustomerIconGrp'><FontAwesomeIcon className='CustomerUsesCircle' icon={faUserCircle}></FontAwesomeIcon></div>
                      <div  className='CustomerGrp' style={{width:"40%"}}>
                      <p className='CustomerGrpLables'>Id</p>
                      <p className='CustomerGrpValues'>{items.Customer_Id}</p>
                      </div>
                      <div  className='CustomerGrp'style={{width:"80%"}} >
                      <p className='CustomerGrpLables'>Customer Name</p>
                      <p className='CustomerGrpValues'>{items.Customer_Name}</p>
                      </div>
                    </div>
                    <div className='CustomerGrp'>
                      <p className='CustomerGrpLables'>Customer Contact</p>
                      <p className='CustomerGrpValues'>{items.Contact1}</p>
                    </div>
                    <div className='CustomerGrp'>
                      <p className='CustomerGrpLables'>Aadhar Number</p>
                      <p className='CustomerGrpValues'>{(items.Aadhar_Number)}</p>
                    </div>
                    <div className='CustomerGrpBtn'>
                      <FontAwesomeIcon className='CustomerEditIcon' title='Edit' icon={faEdit} onClick={()=>handleEdit(items)}></FontAwesomeIcon>
                      <FontAwesomeIcon className='CustomerDeleteIcon' title='Delete' onClick={()=>handleDelete(items)} icon={faTrash}></FontAwesomeIcon>
                    </div>
                  </div>
                    </>
                })} 
                    */
